import { render } from "./VacationTemplateDetails.vue?vue&type=template&id=6ee56e2c&scoped=true"
import script from "./VacationTemplateDetails.vue?vue&type=script&lang=js"
export * from "./VacationTemplateDetails.vue?vue&type=script&lang=js"

import "./VacationTemplateDetails.vue?vue&type=style&index=0&id=6ee56e2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee56e2c"]])

export default __exports__